import { render, staticRenderFns } from "./ImportBookings.vue?vue&type=template&id=0ff91a94&"
import script from "./ImportBookings.vue?vue&type=script&lang=js&"
export * from "./ImportBookings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports